<kendo-card class="w-100">
  <kendo-card-header>
    @if (title() || menu() || showCollapse() || showClose()) {
      <div class="row">
        <div class="col-6">
          <h5><ng-container *ngTemplateOutlet="title()"></ng-container></h5>
        </div>
        <div class="col-6">
          @if (menu()) {
            <i (click)="toggleMenu()" class="fas fa-ellipsis-v">
              <span #anchor></span>
              @if (showMenu()) {
                <kendo-popup
                  [anchor]="anchor"
                  [anchorAlign]="{ horizontal: 'right', vertical: 'bottom' }"
                  [popupAlign]="{ horizontal: 'right', vertical: 'top' }"
                  (anchorViewportLeave)="hideMenu()"
                >
                  <ng-container *ngTemplateOutlet="menu()"></ng-container>
                </kendo-popup>
              }
            </i>
          }
          @if (showCollapse()) {
            <i
              (click)="collapseClick()"
              class="fas"
              [class.fa-angle-up]="!isCollapsed()"
              [class.fa-angle-down]="isCollapsed()"
            ></i>
          }
          @if (showClose()) {
            <i (click)="closeClick()" class="fas fa-times"></i>
          }
        </div>
      </div>
    }
  </kendo-card-header>
  @if (!isCollapsed()) {
    <kendo-card-body>
      <ng-container *ngTemplateOutlet="body()"></ng-container>
    </kendo-card-body>
  }
</kendo-card>
